import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

export const DeleteDialog = (props: { open: boolean; handleClose: (deleted: boolean) => void }) => {
  return (
    <Dialog open={props.open} onClose={() => props.handleClose(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{'Really delete this Tag?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Really delete this Tag?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose(false)}>Don't</Button>
        <Button onClick={() => props.handleClose(true)} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const CannotDeleteTagWarning = (props: { open: boolean; setOpen: (open: boolean) => void }) => {
  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{'Cannot delete a Tag that is in Use!'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">A Tag that is in use cannot be deleted.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setOpen(false)}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};
